import { useState } from 'react';

import Button from '@mui/material/Button';
import FormGroup from '@mui/material/FormGroup';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Alert from '@mui/material/Alert';
import Autocomplete from '@mui/material/Autocomplete';

const PetOwnerSignupForm = (props) => {
  const {
    formSubmitError,
    submitForm,
  } = props;

  const [formData, setFormData] = useState({
    petType: null,
    petSize: null,
    address: '',
    passport: null,
    driverLicense: null,
  });
  const [formEntryError, setFormEntryError] = useState({
    petTypeError: null,
    petSizeError: null,
    addressError: null,
    passportError: null,
    driverLicenseError: null,
  });
  const [agreedToComm, setAgreedToComm] = useState(false);
  const [agreedToTerms, setAgreedToTerms] = useState(false);

  const petTypes = [
    { label: 'Cat', value: 'cat' },
    { label: 'Dog', value: 'dog' },
  ];

  const petSizes = [
    { label: 'Big' },
    { label: 'Small' },
  ];

  const handleOnChange = (key, value) => {
    const errorKey = `${key}Error`;
    setFormEntryError({
      ...formEntryError,
      [errorKey]: null,
    });
    setFormData({
      ...formData,
      [key]: value,
    });
  };

  const validateFormData = () => {
    const error = {
      petTypeError: null,
      petSizeError: null,
      addressError: null,
      passportError: null,
      driverLicenseError: null,
    };
    // if (!formData.petType) {
    //   error.petTypeError = 'Pet type is required';
    // }
    // if (!formData.petSize) {
    //   error.petSizeError = 'Pet size is required';
    // }
    // if (!formData.address) {
    //   error.addressError = 'Address is required';
    // }
    // if (!formData.passport) {
    //   error.passportError = 'Passport is required';
    // }
    // if (!formData.driverLicense) {
    //   error.driverLicenseError = 'Driver\'s License is required';
    // }
    setFormEntryError(error);
    return Object.keys(error).reduce(
      (prevVal, key) => prevVal && error[key] === null,
      true,
    );
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const isDataValid = validateFormData();
    if (!isDataValid) return;
    submitForm(formData);
  };

  return (
    <Container
      component="main"
      maxWidth="xs"
      sx={{
        height: 'calc(100vh - 100px)',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Typography component="h1" variant="h6">
          Sign Up as a Pet Owner with Dogecare!
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Autocomplete
              required
              id="pet-type-input"
              options={petTypes}
              getOptionLabel={option => option.label}
              isOptionEqualToValue={(op, selected) => op.value === selected.value}
              sx={{ width: '49.5%' }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Pet Type"
                  error={formEntryError.petTypeError !== null}
                  helperText={formEntryError.petTypeError}
                />
              )}
              onChange={(_, selectedValue) => handleOnChange('petType', selectedValue)}
            />
            <Autocomplete
              required
              id="pet-size-input"
              options={petSizes}
              getOptionLabel={option => option.label}
              isOptionEqualToValue={(op, selected) => op.value === selected.value}
              sx={{ width: '49.5%' }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Pet Size"
                  error={formEntryError.petSizeError !== null}
                  helperText={formEntryError.petSizeError}
                />
              )}
              onChange={(_, selectedValue) => handleOnChange('petSize', selectedValue)}
            />
          </div>
          <TextField
            id="address-input"
            label="Main address"
            name="address"
            multiline
            rows={3}
            fullWidth
            sx={{ mt: 1.5 }}
            value={formData.address}
            onChange={e => handleOnChange(e.target.name, e.target.value)}
            error={formEntryError.addressError !== null}
            helperText={formEntryError.addressError}
          />
          <Typography
            component="small"
            variant="small"
            sx={{ display: 'block', mt: 1 }}
          >
            {formData.passport?.name}
          </Typography>
          <Button
            variant="contained"
            component="label"
            fullWidth
            color="secondary"
            sx={{ alignSelf: 'flex-start', mt: 1 }}
          >
            Upload Passport
            <input
              type="file"
              name="passport"
              hidden
              onChange={e => handleOnChange(e.target.name, e.target.files[0])}
            />
          </Button>
          <Typography
            component="small"
            variant="small"
            sx={{ display: 'block', mt: 1 }}
          >
            {formData.driverLicense?.name}
          </Typography>
          <Button
            variant="contained"
            component="label"
            fullWidth
            color="secondary"
            sx={{ alignSelf: 'flex-start', mt: 1 }}
          >
            Upload Driver's License
            <input
              type="file"
              name="driverLicense"
              hidden
              onChange={e => handleOnChange(e.target.name, e.target.files[0])}
            />
          </Button>
          {(formEntryError.passportError || formEntryError.driverLicenseError) && (
            <Alert severity="error" sx={{ mt: 2 }}>
              <div>{formEntryError.passportError}</div>
              <div>{formEntryError.driverLicenseError}</div>
            </Alert>
          )}
          <FormGroup sx={{ mt: 1.5 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={agreedToComm}
                  value={agreedToComm}
                  onChange={e => setAgreedToComm(e.target.checked)}
                />
              }
              label="I agree to communications from DogeCare"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={agreedToTerms}
                  value={agreedToTerms}
                  onChange={e => setAgreedToTerms(e.target.checked)}
                />
              }
              label="I agree to Terms & Conditions"
            />
          </FormGroup>
          {formSubmitError && (
            <Alert severity="error" sx={{ mt: 1 }}>{formSubmitError}</Alert>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={!agreedToComm || !agreedToTerms}
            sx={{ mt: 3, mb: 2 }}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default PetOwnerSignupForm;
